import { produce } from "immer";
import {
  //
  ADD_HOME_GROUP_ADMIN,
  ADD_HOME_GROUP_ADMIN_FAILURE,
  ADD_HOME_GROUP_ADMIN_SUCCESS,
  //
  DELETE_HOME_GROUP_ADMIN,
  DELETE_HOME_GROUP_ADMIN_SUCCESS,
  DELETE_HOME_GROUP_ADMIN_FAILURE,
  //
  EDIT_HOME_GROUP_ADMIN,
  EDIT_HOME_GROUP_ADMIN_FAILURE,
  EDIT_HOME_GROUP_ADMIN_SUCCESS,
  //
  FETCH_HOME_GROUP_ADMINS,
  FETCH_HOME_GROUP_ADMINS_FAILURE,
  FETCH_HOME_GROUP_ADMINS_SUCCESS,
  //
  GET_VIEW_DATA,
  GET_VIEW_DATA_FAILURE,
  GET_VIEW_DATA_SUCCESS,
  //
  OPEN_ADMIN_ADD_MODAL,
  CLOSE_ADMIN_ADD_MODAL,
  //
  GET_CHECK_MASTER_ADMIN,
  GET_CHECK_MASTER_ADMIN_FAILURE,
  GET_CHECK_MASTER_ADMIN_SUCCESS,
  //
  OPEN_ADMIN_EDIT_MODAL,
  CLOSE_ADMIN_EDIT_MODAL,
  SET_ADMIN_SUCCESS,
  SET_ADMIN_FAILURE,
  //
  TOGGLE_INVITE_MODAL,
  //
  INVITE_ADMIN,
  INVITE_ADMIN_SUCCESS,
  INVITE_ADMIN_FAILURE,
} from "./constants";

export const initialState = {
  isFetchingHomesAdmin: false,
  HomesAdmin: [],
  // Add / Edit
  isSubmitting: false,
  // View
  isFetching: false,
  currentHomeAdmin: {},
  // Delete
  isDeleting: false,
  //
  isAdminAddModalOpen: false,
  isAdminEditModalOpen: false,
  isSearching: false,
  searchHomeList: [],
  //
  inviteModal: { open: false },
  isInviting: false,
};

const HomeGroupAdminReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      // List
      case FETCH_HOME_GROUP_ADMINS:
        draft.isFetchingHomesAdmin = true;
        draft.currentHomeAdmin = {};
        break;
      case FETCH_HOME_GROUP_ADMINS_SUCCESS:
        draft.isFetchingHomesAdmin = false;
        draft.HomesAdmin = action.payload;
        break;
      case FETCH_HOME_GROUP_ADMINS_FAILURE:
        draft.isFetchingHomesAdmin = false;
        break;
      // View
      case GET_VIEW_DATA:
        draft.isFetching = true;
        draft.currentHomeAdmin = {};
        break;
      case GET_VIEW_DATA_SUCCESS:
        draft.isFetching = false;
        draft.currentHomeAdmin = action.payload;
        break;
      case GET_VIEW_DATA_FAILURE:
        draft.isFetching = false;
        break;
      // Add
      case ADD_HOME_GROUP_ADMIN:
        draft.isSubmitting = true;
        break;
      case ADD_HOME_GROUP_ADMIN_SUCCESS:
        draft.isSubmitting = false;
        break;
      case ADD_HOME_GROUP_ADMIN_FAILURE:
        draft.isSubmitting = false;
        break;
      // Edit
      case EDIT_HOME_GROUP_ADMIN:
        draft.isSubmitting = true;
        break;
      case EDIT_HOME_GROUP_ADMIN_SUCCESS:
        draft.isSubmitting = false;
        break;
      case EDIT_HOME_GROUP_ADMIN_FAILURE:
        draft.isSubmitting = false;
        break;
      // Delete
      case DELETE_HOME_GROUP_ADMIN:
        draft.isDeleting = true;
        break;
      case DELETE_HOME_GROUP_ADMIN_SUCCESS:
        draft.isDeleting = false;
        break;
      case DELETE_HOME_GROUP_ADMIN_FAILURE:
        draft.isDeleting = false;
        break;
      case OPEN_ADMIN_ADD_MODAL:
        draft.isAdminAddModalOpen = true;
        break;
      case CLOSE_ADMIN_ADD_MODAL:
        draft.isAdminAddModalOpen = false;
        break;
      case GET_CHECK_MASTER_ADMIN:
        draft.isFetching = true;
        draft.currentHomeAdmin = {};
        break;
      case GET_CHECK_MASTER_ADMIN_SUCCESS:
        draft.isFetching = false;
        draft.currentHomeAdmin = action.payload;
        break;
      case GET_CHECK_MASTER_ADMIN_FAILURE:
        draft.isFetching = false;
        break;
      //
      case OPEN_ADMIN_EDIT_MODAL:
        draft.isFetching = true;
        draft.isAdminEditModalOpen = true;
        draft.isAdminAddModalOpen = false;
        draft.currentHomeAdmin = {};
        break;
      case CLOSE_ADMIN_EDIT_MODAL:
        draft.isAdminEditModalOpen = false;
        draft.isAdminAddModalOpen = false;
        draft.currentHomeAdmin = {};
        break;
      case SET_ADMIN_SUCCESS:
        draft.isFetching = false;
        draft.currentHomeAdmin = action.payload;
        break;
      case SET_ADMIN_FAILURE:
        draft.isFetching = false;
        draft.currentHomeAdmin = {};
        break;

      case TOGGLE_INVITE_MODAL:
        draft.inviteModal = action?.payload;
        break;

      //
      case INVITE_ADMIN:
        draft.isInviting = true;
        break;
      case INVITE_ADMIN_SUCCESS:
        draft.isInviting = false;
        break;
      case INVITE_ADMIN_FAILURE:
        draft.isInviting = false;
        break;

      default:
        return state;
    }
  });

export default HomeGroupAdminReducer;
